import { DataBean } from "../DataBean";

export class RawMaterialCatalogByRawMaterialRequest extends DataBean {


    public async getRawMaterialCatalogByRawMaterialRequest(idRawMaterialRequest:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialCatalogByRawMaterialRequest_Number", [idRawMaterialRequest]);
    }
    
 
}